module.exports = __webpack_public_path__ + "static/media/PLAY_MACHINES_1_Mobile.dc15c5ca.jpg";